import React, { TableHead, TableBody, TableRow } from "@mui/material"
import PEReprodSectionField from "./PEReprodSectionField"
import PEReprodTableContainer from "./PEReprodTableContainer"
import { StyledTable, StyledHeaderCell } from "../../../components/styled/StyledTableComponents"

const PEReprodSectionsField = ({
	sections = [],
	errors,
	setFieldValue,
	setFieldTouched,
}) => {
	const handleChangeSectionRealWeight = (value, index) => {
		// Only update the compressiblePackagingWeight value
		// Don't recalculate forecast numbers - those are based on actual production, not planned reproduction
		setFieldValue(`sections[${index}].compressiblePackagingWeight`, value)
	}

	const headerLabels = ["Élements à barquetter", "Quantité pesée / Théorique", "À reproduire en priorité", "À reproduire selon disponibilité"]

	return (
		<PEReprodTableContainer
			icon="distributionBySections.svg"
			title="Répartition par sections"
			description="Saisissez les quantités à mettre en reprod."
		>
			<StyledTable>
				<TableHead>
					<TableRow>
						{headerLabels.map((label, index) => (
							<StyledHeaderCell key={index}>
								{label}
							</StyledHeaderCell>
						))}
					</TableRow>
				</TableHead>

				<TableBody>
					{sections.map((currentSection, index) => (
						<PEReprodSectionField
							key={index}
							section={currentSection}
							sectionIndex={index}
							setFieldTouched={setFieldTouched}
							onChangeSectionRealWeight={handleChangeSectionRealWeight}
							errors={errors}
							isLastItem={index === sections.length - 1}
						/>
					))}
				</TableBody>
			</StyledTable>
		</PEReprodTableContainer>
	)
}


export default PEReprodSectionsField
